import React, { createContext, useContext, useState, useCallback } from "react";

const DICT = {
  ru: {
    brand: "NORD",
    welcome_title: "Пополнить счёт",
    welcome_sub: "брокерский счёт",
    start: "ПОПОЛНИТЬ",
    phone_title: "Ваш телефон",
    amount_title: "Сумма",
    next: "ДАЛЕЕ",
    show_qr: "ПОКАЗАТЬ QR",
    scan_title: "Сканируйте QR",
    open_bank: "Банк",
    camera: "Камера",
    scan: "Готово",
    waiting: "Ждём оплату…",
    success: "Оплачено!",
    fail: "Не получилось",
    expired: "Время вышло",
    retry: "ЕЩЁ РАЗ",
    done: "ГОТОВО",
    demo_note: "ДЕМО-РЕЖИМ",
    sbp: "СБП",
    error_net: "Нет связи",
    receipt: "Чек",
    operation_no: "№ операции",
    phone_lbl: "Телефон",
    date_lbl: "Дата",
    save_receipt: "СОХРАНИТЬ ЧЕК",
    receipt_saved: "Чек сохранён",
    pay_now: "ОПЛАТИТЬ",
    or_scan: "или сканируйте QR с другого телефона",
    slow_bank: "Банк долго отвечает… Подождите или попробуйте позже",
    phone_not_found: "Номера нет в базе. Позвоните менеджеру",
    checking: "Проверяем…",
    terms_agree: "Я согласен и присоединяюсь к",
    terms_link: "Публичной оферте, условиям и правилам сервиса",
    rate_lbl: "Онлайн-курс",
    footer_id_text: "Пройти идентификацию можно отправив запрос на ящик",
    how_it_works: "Как оплатить",
    got_it: "Понятно",
    listen: "Слушать",
  },
  es: {
    brand: "NORD",
    welcome_title: "Recargar cuenta",
    welcome_sub: "cuenta de bróker",
    start: "RECARGAR",
    phone_title: "Su teléfono",
    amount_title: "Importe",
    next: "SIGUIENTE",
    show_qr: "MOSTRAR QR",
    scan_title: "Escanee el QR",
    open_bank: "Banco",
    camera: "Cámara",
    scan: "Listo",
    waiting: "Esperando el pago…",
    success: "¡Pagado!",
    fail: "No funcionó",
    expired: "Tiempo agotado",
    retry: "OTRA VEZ",
    done: "LISTO",
    demo_note: "MODO DEMO",
    sbp: "SBP",
    error_net: "Sin conexión",
    receipt: "Recibo",
    operation_no: "N.º de operación",
    phone_lbl: "Teléfono",
    date_lbl: "Fecha",
    save_receipt: "GUARDAR RECIBO",
    receipt_saved: "Recibo guardado",
    pay_now: "PAGAR",
    or_scan: "o escanee el QR desde otro tel\u00e9fono",
    slow_bank: "El banco tarda en responder\u2026 Espere o int\u00e9ntelo m\u00e1s tarde",
    phone_not_found: "N\u00famero no registrado. Llame a su gerente",
    checking: "Verificando\u2026",
    terms_agree: "Acepto y me adhiero a la",
    terms_link: "Oferta P\u00fablica, condiciones y reglas del servicio",
    rate_lbl: "Tipo de cambio",
    footer_id_text: "Puede pasar la identificaci\u00f3n enviando una solicitud al correo",
    how_it_works: "C\u00f3mo pagar",
    got_it: "Entendido",
    listen: "Escuchar",
  },
};

const LangContext = createContext({ lang: "ru", t: DICT.ru, setLang: () => {} });

export const LangProvider = ({ children }) => {
  // Spanish is the default UI language; Russian stays available via the switcher
  const [lang, setLangState] = useState(() => localStorage.getItem("fva_lang") || "es");
  const setLang = useCallback((l) => {
    localStorage.setItem("fva_lang", l);
    setLangState(l);
  }, []);
  const t = DICT[lang] || DICT.ru;
  return (
    <LangContext.Provider value={{ lang, t, setLang }}>{children}</LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
